module.exports = __webpack_public_path__ + "static/GeekExpress-42314bc60496035973d38a45556ee41d.png";